import { useLocation } from "react-router-dom"
import { UserInfoResponse } from "@logto/react"
import { Typography } from "@mui/material"
import { ACCESS } from "@dictybase/auth-mui5"

const Edit = () => {
  const location = useLocation()
  const user = location.state as UserInfoResponse
  return <Typography variant="h1">Edit {user.name}</Typography>
}

// eslint-disable-next-line import/no-default-export
export default Edit
export const access = ACCESS.protected
